/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const StyleTrait = require('../types/StyleTrait')
const CElementGraphique = require('./CElementGraphique')
module.exports = CElementLigne

/**
 * Classe ancêtre de tous les éléments qui se tracent comme une ligne, fermée ou non.
 * @constructor
 * @extends CElementGraphique
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {mtg32.CImpementationProto} impProto : null ou la construction proprétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur de tracé
 * @param {Boolean} nomMasque : true si le nom est masqué.
 * @param {Integer} dec_x : Décalage horizontal du nom
 * @param {Integer} dec_y ; Décalage vertical du nom
 * @param {Boolean} masque : true si l'objet est masqué
 * @param {String} nom : Le nom.
 * @param {Integer} tailleNom : Indice donnant la taille du nom.
 * @param {StyleTrait} style : Le style de trait utilisé.
 * @returns {CElementLigne}
 */
function CElementLigne (listeProprietaire, impProto, estElementFinal, couleur, nomMasque,
  dec_x, dec_y, masque, nom, tailleNom, style) {
  if (arguments.length === 0) return; // Ajout version 4.9.9.4
  if (arguments.length === 1) {
    CElementGraphique.call(this, listeProprietaire);
    // Ajout version 5.0
    this.style = new StyleTrait(listeProprietaire); // Le style de trait doit connaître la liste pour adapter son style aux écarns HD
    //
  }
  else {
    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur,
      nomMasque, dec_x, dec_y, masque, nom, tailleNom);
    this.style = style;
    // Modification version 4.9.9.4
    /* Modifié version 5.0
    this.stroke = StyleTrait.stroke(this.style);
    this.strokewidth = StyleTrait.strokeWidth(this.style);
    */
   /* Inutile version 5.0
   if (this.style) { // Test àa cause des objets internes non dessiné qui n'ont pas de style
      this.stroke = style.stroke;
      this.strokewidth = style.strokeWidth;
    }
    */
  }
}
CElementLigne.prototype = new CElementGraphique();
CElementLigne.prototype.constructor = CElementLigne;
CElementLigne.prototype.superClass = "CElementGraphique";
CElementLigne.prototype.className = "CElementLigne";

/**
 * Donne à l'objet le style de trait style
 * @param {StyleTrait} style
 * @returns {undefined}
 */
CElementLigne.prototype.donneStyle = function(style) {
   this.style = style;
};



CElementLigne.prototype.read = function(inps, list){
  CElementGraphique.prototype.read.call(this, inps, list);
  if (list.numeroVersion < 15) this.style.readOld(inps, list, true);
  else this.style.read(inps, list);
};
CElementLigne.prototype.write = function(oups, list){
  CElementGraphique.prototype.write.call(this, oups, list);
  this.style.write(oups);
};
